<template>
    <div class="talent">
        <a-table 
            :columns="columns" 
            :dataSource="hireList"
            :pagination="pagination"
            @change="changePage"
        >
            <a slot="action" href="javascript:;">Delete</a>
            <div slot="expandedRowRender" slot-scope="record" style="margin: 0">
                <div v-html="record.job_duty"></div>
            </div>
        </a-table>
    </div>
</template>
<script>
const columns = [
  { title: '职位名称', dataIndex: 'job_name', key: 'job_name' },
  { title: '招聘人数', dataIndex: 'hire_number', key: 'hire_number' },
  { title: '职位类别', dataIndex: 'job_type', key: 'job_type' },
  { title: '工作地点', dataIndex: 'job_address',key: 'job_address'},
  { title: '发布时间', dataIndex: 'publish_time',key: 'publish_time'},
];
import {Table} from 'ant-design-vue'
import {getHireListApi} from "@/request/api"
export default {
    name:"talent",
    components:{aTable:Table},
    mounted(){
        this.init()
    },
    data(){
        return{
            columns,
            hireList:[],
            pagination:{pageSize:10,total:0},
            searchInfo:{
                page_size:10,
                page:1
            }
        }
    },
    methods:{
        init(){
            this.getToken(getHireListApi,this.searchInfo,res=>{
                this.hireList=res.data.data_info
                this.pagination.total=res.data.data_count
            })
        },
        changePage(data){
            this.searchInfo.page=data.current
            this.init()
        },
    }
}
</script>
<style lang="stylus">
.talent
    .ant-table-thead > tr > th
        background:#dbdbdb;
</style>
<style lang="stylus" scoped>
.talent
    padding:30px;
    ol
        li
            line-height:30px;
    .button
        width:120px;
        height:38px;
        margin:20px auto 0;
        background:#fd8d56;
        color:#fff;
        text-align:center;
        line-height:38px;
        border-radius:5px;
    
</style>